import React, { useEffect, useState, useContext } from "react"
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, ContactsOutlined, EditOutlined, ExclamationCircleOutlined, ReadOutlined } from '@ant-design/icons';
import axios from "axios";
import { Avatar, Table, Switch, ConfigProvider, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Carousel, Input } from "antd";
import NewTable from "./components/NewTable";
import AdminClassEncodingModal from "./components/AdminClassEncodingModal";
import Label_language from '../language';
const label_language = Label_language.ems.children

const AdminClassEncoding = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([undefined, undefined])
    const [mid, set_mid] = useState('');
    const [second_edit, set_second_edit] = useState(false);
    const [last_edit, set_last_edit] = useState(false);
    const [alph, set_alph] = useState('');
    const [all_alph, set_all_alph] = useState('');
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [blog_open, set_blog_open] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const [custom_filter_value, set_custom_filter_value] = useState(null);
    const { confirm } = Modal;
    const [datas, setDatas] = useState([]);
    const [msg, setMsg] = useState(0);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    const [default_column, set_default_column] = useState([
        {
            title: '星期',
            key: 'week_name',
            dataIndex: 'week_name',
            align: 'center',
        },
        {
            title: '編碼名稱',
            key: 'week_code',
            dataIndex: 'week_code',
            align: 'center',
        },
        {
            title: label_language.Common.children.control[language],
            align: 'center',
            sorter: false,
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>{label_language.Common.children.edit[language]}</Button>
                </>
            )
        },
    ]);
    const showMessage = (value) => {
        confirm({
            title: label_language.Common.children.sure_delete[language],
            icon: <ExclamationCircleOutlined />,
            okText: label_language.Common.children.sure[language],
            okType: 'primary',
            cancelText: label_language.Common.children.cancel[language],
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnEditRow = (record) => {
        setTitle('修改編碼');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record)
    }
    const getData = (param, sort, filter, checklist) => {
        // console.log(param);
        set_loading(true);
        set_choose_column(checklist);
        set_custom_filter_value(param?.keyword);
        return axios
            .get('/cramSchool/api/class/coding', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    // employment_time_start: search_date[0],
                    // employment_time_end: search_date[1],  
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },
                // paramsSerializer: function (params) {
                //     const NewParams = Object.entries(params).map(([map_key, map_value]) => {
                //         if (map_key === 'order') {
                //             return Object.entries(map_value).map(([map_value_key,map_value_value], i) => {
                //                 return `order[${i}][column]=${map_value_key}&order[${i}][type]=${map_value_value}`;
                //             })
                //         }else if (map_key === 'custom_filter_key') {
                //             return map_value.map(map_item=>`custom_filter_key[]=${map_item}`).join("&");
                //         }else{
                //             return `${map_key}=${map_value}`;
                //         }
                //     })
                //     return NewParams.join("&")
                // },
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.first);
                set_mid(response.data.mid);
                set_all_alph(response.data.last);
                set_alph(response.data.last.filter((item) => item.openset == 0))
            })
            .finally(() => {
                set_loading(false)
            })
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'encode',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'encode'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        reload()
    }, [search_date])
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/class/coding`, {
                data: [{ teacher_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();

                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                }
            })

    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'teacher_id': value })
            })
            axios
                .delete(`/cramSchool/api/class/coding`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.delete_error[language],
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.delete_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnAddRow = () => {
        setTitle('新增編碼');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
    }

    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleEdit = (type) => {
        let data_tmp = []
        if (type == 'first') {
            data_tmp = [editcard]
        } else if (type == 'mid') {
            data_tmp = [{ mid_code: editcard }];
        } else {
            console.log(editcard);
            let data_json = {};
            all_alph.map((value, i) => {
                if (value.alphabet_name == editcard.alphabet_id1) {
                    data_json[`alphabet_id1`] = value.alphabet_id
                } else if (value.alphabet_name == editcard.alphabet_id2) {
                    data_json[`alphabet_id2`] = value.alphabet_id
                }
            })
            data_tmp.push(data_json);
        }
        axios
            .patch(`/cramSchool/api/class/coding`, data_tmp)
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    reload();
                    set_second_edit(false);
                    set_last_edit(false);
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    reload();
                    set_second_edit(false);
                    set_last_edit(false);
                }
            })
    }
    const handleSubmit = (file_id) => {
        if (editcard.name == undefined || editcard.name == '') {
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫姓名',
            });
        } else {
            axios
                .post(`/cramSchool/api/class/coding`, [
                    {
                        ...editcard,
                        file_id,
                    }
                ])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        reload();
                    }
                })
        }
    }
    return (
        <>
            {contextHolder}
            <AdminClassEncodingModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                // setData={setData}
                // data={data}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
            // handleSubmit={handleSubmit}
            />
            <Row justify={'space-between'} style={{ paddingTop: '10px' }} gutter={[8, 8]}>
                <Col span={24}>第一碼</Col>
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'ClassEncodeList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add={false}
                        // add_button_title={'新增課程編碼'}//新增按鈕上的名稱
                        // handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'id'}//key
                        // setSelectedRowKeys={setSelectedRowKeys}
                        // selectedRowKeys={selectedRowKeys}
                        // handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        searchdate={false}
                        delete={false}
                    ></NewTable>
                </Col>
                <Col span={24}>第二碼</Col>
                <Col span={24}>
                    <Row gutter={16}>
                        <Col>編碼名稱：{second_edit ? <><Input style={{ width: 50 }} value={editcard}
                            onChange={e => setEditCard(e.target.value)}></Input></> : <>{mid}</>}</Col>
                        <Col>{second_edit ? <Button type="primary"
                            onClick={e => {
                                handleEdit('mid');
                            }}>儲存</Button> : <Button type="primary"
                                onClick={e => {
                                    setEditCard(mid);
                                    set_second_edit(true);
                                }}>編輯</Button>}</Col>
                    </Row>
                </Col>
                <Col span={24}>第三碼範圍</Col>
                <Col span={24}>
                    <Row gutter={16}>
                        <Col>
                            <Row gutter={4}>
                                {last_edit ? <>
                                    <Col><Input style={{ width: 50 }} value={editcard.alphabet_id1}
                                        onChange={e => setEditCard(pre => {
                                            return ({
                                                ...pre,
                                                alphabet_id1: e.target.value
                                            })
                                        })}></Input></Col>
                                    <Col>~</Col>
                                    <Col><Input style={{ width: 50 }} value={editcard.alphabet_id2}
                                        onChange={e => setEditCard(pre => {
                                            return ({
                                                ...pre,
                                                alphabet_id2: e.target.value
                                            })
                                        })}></Input></Col></> : <>
                                    <Col>{alph[0]?.alphabet_name}</Col>
                                    <Col>~</Col>
                                    <Col>{alph[1]?.alphabet_name}</Col>
                                </>}
                            </Row>
                        </Col>
                        <Col>{last_edit ? <Button type="primary"
                            onClick={e => {
                                handleEdit('last');
                            }}
                        >儲存</Button>
                            : <Button type="primary"
                                onClick={e => {
                                    setEditCard({ alphabet_id1: alph[0]?.alphabet_name, alphabet_id2: alph[1]?.alphabet_name });
                                    set_last_edit(true);
                                }}>編輯</Button>}</Col>
                    </Row>
                </Col >
            </Row >
        </>
    )
}
export default AdminClassEncoding;
